module.exports = __webpack_public_path__ + "img/su-service.2a7d3d5d.png";